// @flow
/* ----------------------- Global ------------------ */
import {
  produce,
} from 'immer';
/* -----------------Types--------------- */
import {
  SET_FOCUS,
} from './actionTypes';
import type {
  ChromeHeaderState,
} from './types';
/* -----------------Constants--------------- */
import {
  initialState,
} from './constants';

const toggleFocus = (
  state: ChromeHeaderState,
) => produce(state, (draft) => {
  const { searchFocused } = state;
  draft.searchFocused = !searchFocused;
});
const chromeHeaderReducer = (
  state: ChromeHeaderState = initialState,
  action: *,
) => {
  switch (action.type) {
    case SET_FOCUS:
      return toggleFocus(state);
    default:
      return initialState;
  }
};

export default chromeHeaderReducer;
